import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";

import Header from "../components/ContainerHeader";
import Form from "../components/organizationFound/Form";

import { setActiveHost, setActiveServer } from "../actions/activeActions";

const OrganizationFound = ({ history, activeHost, activeServer }) => {
  if (activeServer)
    return (
      <div className="flex-col">
        <Header title="Založit novou organizaci" />
        {activeHost.address && activeHost.activeHost !== "" ? (
          <Form
            hostId={activeHost.id}
            serverId={activeServer.id}
            history={history}
          />
        ) : (
          <p>Vyplňte, prosím adresu hostu "{activeHost.name}".</p>
        )}
      </div>
    );

  return <div />;
};

export default compose(
  connect(
    ({ active: { activeServer, activeHost } }) => ({
      activeServer,
      activeHost
    }),
    {
      setActiveHost,
      setActiveServer
    }
  ),
  lifecycle({
    componentWillMount() {
      const { activeHost, activeServer, history } = this.props;

      if (!activeHost || !activeServer) {
        history.push("/hosts");
      }
    },
    componentWillUnmount() {
      const { setActiveHost, setActiveServer } = this.props;

      setActiveHost(null);
      setActiveServer(null);
    }
  })
)(OrganizationFound);



// WEBPACK FOOTER //
// ./src/pages/OrganizationFound.js